export const routes = {
  home: '/',
  swap: '/swap',
  pools: '/pools',
  cosmic: '/cosmic',
  bridge: '/bridge',
  stake: '/stake',
  claim: '/claim'
};
